import React from 'react';

import { Box, BoxProps, Container, useTheme } from '@chakra-ui/react';

interface IFormContainer {
  width?: string;
  disableShadow?: boolean;
  pt?: BoxProps['pt'];
  pb?: BoxProps['pb'];
  mt?: BoxProps['mt'];
  children: React.ReactNode;
}

/**
 * Container with a card UI view for forms content
 * @component
 * @param    {IFormContainer}   props     Component props
 * @param    {React.ReactNode}  props.children  Form content
 * @example
 * <FormContainer formSize="small">
 *   ...form content
 * </FormContainer>
 */
export const FormContainer: React.FC<IFormContainer> = ({
  width,
  disableShadow,
  mt,
  pb,
  pt,
  children,
}) => {
  const theme = useTheme();

  return (
    <Box
      maxW={width ?? 'card.md'}
      mt={mt ?? { base: '4.375rem', md: '5.375rem', lg: '6.5rem' }}
      mx='auto'
      pb={pb ?? 'xl'}
      pt={pt ?? 'xl'}
      width='100%'
    >
      <Container
        borderRadius='lg'
        borderWidth={disableShadow ? '0px' : '2px'}
        boxShadow={disableShadow ? undefined : theme.shadows.subtleDark}
        maxWidth='auto'
        px='lg'
        py='lg'
        width='100%'
      >
        {children}
      </Container>
    </Box>
  );
};
